<template>
  <div>
    <v-client-table :columns="columns" :data="logsWithId" :options="options" :theme="theme" id="dataTable">
      <div slot="afterLimit" class="card-header-actions">
        <download-excel
          class   = "btn btn-default"
          type    = "csv"
          name    = "logs.xls"
          :data   = "logsToCsv">
            <i class="fa fa-file-excel-o"></i>
        </download-excel>
      </div>
      <div slot="timestamp" slot-scope="props">
        <router-link :to="{name: 'Log', params: {id: props.row.id}}">{{(props.row.timestamp && props.row.timestamp.seconds) ? (new Date(props.row.timestamp.seconds*1000)).toLocaleString(): ''}}</router-link>
      </div>
      <b-button pill variant="outline-light" size="sm" slot="delete" slot-scope="props" @click.stop="confirmDelete(props.row)">
        <i class="fa fa-trash"></i>
      </b-button>
      <div slot="child_row" slot-scope="props">
        Log ID : {{props.row.id}}
      </div>
    </v-client-table>

    <b-modal title="Delete Log" class="modal-warning" v-model="warningModal" @ok="deleteItem" ok-variant="warning">
      Are you sure to delete?
    </b-modal>
  </div>
</template>

<script>
  import { ClientTable, Event } from 'vue-tables-2'

export default {
    name: 'Logs',
    components: {
      ClientTable,
      Event
    },
    props: {
      userId: {
        type: String,
        required: false
      },
      deviceId: {
        type: String,
        required: false
      },
      searchOption: {
        type: Object,
        required: false,
      }      
    },
    data: function() {
      return {
        idToDelete : null,
        warningModal: false,
        logs: [],
        columns: ['timestamp', 'appVer', 'mobileDevice', 'action', 'param', 'result', 'delete'],
        options: {
          headings: {
            timestamp: 'Timestamp',
            appVersion: 'App Version',
            mobileDevice: 'Mobile Device',
            action: 'Action',
            param: 'Param',
            result: 'Result',
            delete: 'Delete'
          },
          sortable: ['timestamp', 'appVer', 'action', 'param', 'result'],
          filterable: ['timestamp', 'appVer', 'action', 'param', 'result'],
          sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
          templates: {
            param: (h, row, index) => {
                return (row.param) ? JSON.stringify(row.param): ''
            },
            result: (h, row, index) => {
                return (row.result) ? JSON.stringify(row.result): ''
            },
          },
          pagination: {
            chunk: 5,
            edge: false,
            nav: 'scroll'
          }
        },
        useVuex: false,
        theme: 'bootstrap4',
        template: 'default'
      }
    },
    created: function() {
      let query = this.$firebase.firestore().collection('logs')

      if (this.userId) {
        query = query.where('uid', '==', this.$firebase.firestore().collection('users').doc(this.userId))
      } 
      if (this.deviceId) {
        query = query.where('deviceId', '==', this.$firebase.firestore().collection('devices').doc(this.deviceId))
      }
      if (this.searchOption) {
        if (this.searchOption.action && this.searchOption.action.length > 3) {
          query = query.where('action', '==', this.searchOption.action)
        }
        if (this.searchOption.createdFrom && this.searchOption.createdTo) {
          query = query
          .where('timestamp', '>=', this.$moment(this.searchOption.createdFrom, 'YYYY-MM-DD').startOf('day').toDate())
          .where('timestamp', '<=', this.$moment(this.searchOption.createdTo, 'YYYY-MM-DD').endOf('day').toDate())
        }
      } 
      query = query.orderBy('timestamp', 'desc').limit(1000)
      this.$bind('logs', query)
    },
    computed: {
        logsWithId() {
            if (!this.logs) {
                return []
            }
            return this.logs.map(log => {
                return {...log, id: log.id}
            })
        },
        logsToCsv() {
            if (!this.logs || this.logs.length < 1) {
                return []
            }
            return this.logs.map(log => {
              const newLog = {...log}
              delete newLog.uid;
              return newLog;
            })
        }        
    },
    methods: {
        confirmDelete(item) {
          if (!item) {
            return
          }
          this.idToDelete = item.id
          this.warningModal = true
        },
        deleteItem() {
          if (!this.idToDelete) return

          this.$firebase.firestore().collection('logs').doc(this.idToDelete).delete()
          .catch(error => {
            console.error('delete error: ', error)
          })
          this.warningModal = false
        }
    }
  };
</script>

<style lang="scss">
  #dataTable {
    width: 95%;
    margin: 0 auto;

    .VuePagination {
      text-align: center;
      justify-content: center;
    }

    .vue-title {
      text-align: center ;
      margin-bottom: 10px;
    }

    .VueTables__search-field {
      display: flex;
    }
    .VueTables__search-field input {
      margin-left: 0.25rem;
    }

    .VueTables__limit-field {
      display: flex;
    }

    .VueTables__limit-field select {
      margin-left: 0.25rem !important;
    }

    .VueTables__table th {
      text-align: center;
    }

    .VueTables__child-row-toggler {
      width: 16px;
      height: 16px;
      line-height: 16px;
      display: block;
      margin: auto;
      text-align: center;
    }

    .VueTables__child-row-toggler--closed::before {
      content: "+";
    }

    .VueTables__child-row-toggler--open::before {
      content: "-";
    }
  }

</style>
